import { styled } from 'baseui'

export const Card = styled('div', ({ $theme }) => ({
  background: $theme.colors.bg100,
  padding: '0.5rem',
  borderRadius: $theme.borders.radius400,
  boxShadow: $theme.lighting.shadow400,
  display: 'flex',
  'flex-direction': 'column',
}))
export const CardForm = styled('div', ({ $theme }) => ({
  marginTop: '0.5rem',
  background: $theme.colors.bg100,
  padding: '0.25rem',
  borderRadius: $theme.borders.radius400,
  display: 'flex',
  width: '100%',
}))

export const Title = styled('h2', ({ $theme }) => ({
  alignContent: 'left',
  color: $theme.colors.primary,
}))
